import fly from '@/utils/http';
import { RemovePatientParams, UpdateFollowUpParams, UpsertQuestionnaireParams, StopPatientParams } from './type/type';
import { getDoctorInfo } from '@/utils/utils';
import { SourceType, TaskType } from '@/const/business';
import { DepartmentItem, TemplateParams } from '@/formQuestionnaire/type/type';

// 终止患者
export const stopPatient = (stopPatientParams: StopPatientParams) => fly.post('/hospital/terminationFollowUp', stopPatientParams);
// 移除患者
export const apiRemovePatientFromFollowUp = (removePatientParams: RemovePatientParams) => fly.post('/hospital/removePatientFromFollowUp', [removePatientParams]);

// 智能随访 智能表单 诊后计划(详情)
export const getFollowUpDetail = (requireParams = {}) => fly.post('/hospital/getFollowUp', requireParams);

// 删除随访
export const deleteFollowUp = async (followUpId: number) => {
  const { err }: any = await fly.post('/hospital/deleteFollowUp', {
    id: followUpId,
  });
  if (err) throw Error('弹窗拦截');
};

// 修改随访
export const updateFollowUp = (req: UpdateFollowUpParams) => fly.post('/hospital/updateFollowUp', req);

// 保存/修改/删除患教宣传详情
export const savePublicityDetail = (req = {}) => fly.post('/hospital/savePublicityDetail', req);

// 获取子计划
export const getFollowUpChildPlans = async (followUpId: number, onlyInnerSystem = false) => fly.post('/hospital/getFollowUpChildPlans', { followUpId, onlyInnerSystem });

// 获取问卷 我的模板列表
export const getQuestionTemplate = async ({ currentPage, pageSize, templateName, labelIds }: TemplateParams = {
  currentPage: 0,
  pageSize: 10,
  templateName: '',
  labelIds: [],
}) => {
  const res: any = await fly.post('/hospital/getQuestionTemplate', {
    currentPage,
    pageSize,
    templateName,
    labelIds,
  });
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 获取问卷 可引用的模板列表
export const getQuestionReferenceTemplate = async ({ currentPage, pageSize, templateName, labelIds }: TemplateParams = {
  currentPage: 0,
  pageSize: 10,
  templateName: '',
  labelIds: [],
}) => {
  const res: any = await fly.post('/hospital/getQuestionReferenceTemplate', {
    currentPage,
    pageSize,
    templateName,
    labelIds,
  });
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 获取获取 智能随访、智能表单、诊后计划 我的模板列表
export const getFollowUpTemplate = async ({
  sourceType = SourceType.followUp,
  currentPage = 0,
  pageSize = 10,
  templateName = '',
  labelIds = [],
}: TemplateParams) => {
  const params = {
    commonIn: {
      sourceType,
    },
    templateName,
    currentPage,
    labelIds,
    pageSize,
  };
  const res: any = await fly.post('/hospital/getFollowUpTemplate', params);
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 获取获取 智能随访、智能表单、诊后计划 可引用的模板列表
export const getFollowUpReferenceTemplate = async ({
  sourceType = SourceType.followUp,
  currentPage = 0,
  pageSize = 10,
  templateName = '',
  labelIds = [],
}: TemplateParams) => {
  const params = {
    commonIn: {
      sourceType,
    },
    currentPage,
    pageSize,
    templateName,
    labelIds,
  };
  const res: any = await fly.post('/hospital/getFollowUpReferenceTemplate', params);
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 保存问卷
export const postSaveQuestionnaire = async (req = {}) => await fly.post('/hospital/questionnaire', req);

// 保存 智能随访、智能表单、诊后计划
export const setFollowUpNew = async (req) => {
  const res: any = await fly.post('/hospital/setFollowUpNew', {
    ...req.req,
    commonIn: {
      sourceType: req.sourceType,
    },
  });

  const { errCode, err } = res;
  if (errCode !== -100 && err) {
    throw new Error('弹窗拦截');
  }
  return { errCode, err };
};

// 删除问卷
export const apiDeleteQuestionnaire = async (id: number) => {
  const res: any = await fly.post('/hospital/deleteQuestionnaire', {
    id,
  });
  if (res.err) {
    throw new Error('弹窗拦截');
  }
};

// 删除 智能随访、智能表单、诊后计划 模板
export const deletePlanTemplate = async (templateId: number, sourceType: SourceType) => {
  const res: any = await fly.post('/hospital/deleteFollowUpTemplate', {
    commonIn: {
      sourceType,
    },
    templateId,
  });
  if (res.err) {
    throw new Error('弹窗拦截');
  }
};

// 引用模板
export const referenceTemplate = async (req) => {
  const { err, groupId, followUpId }: any = await fly.post('/hospital/importFollowUpTemplate', {
    ...req.req,
    commonIn: {
      sourceType: req.sourceType,
    },
  });
  if (err) {
    return { err };
  }
  return {
    groupId,
    followUpId,
  };
};

// 新建、编辑问卷模板
export const upsertQuestionnaireTemplate = async (req: UpsertQuestionnaireParams) => {
  const res: any = await fly.post('/hospital/upsertQuestionnaireTemplate', req);
  const { errCode, err, templateId } = res;
  return {
    errCode,
    err,
    templateId,
  };
};

//  获取科室列表
export const queryDepartment = async () => {
  const doctorInfo = await getDoctorInfo();
  const { err, rsp }: any = await fly.post('/hospital/queryDepartmentList', {
    hospitalId: doctorInfo.hospitalId,
  });
  if (err) {
    throw new Error('弹窗拦截');
  }
  const departmentList: DepartmentItem[] = rsp?.departmentList || [];
  const list: DepartmentItem[] = [];
  if (!doctorInfo?.isCheckAllInPatients && doctorInfo.value?.departmentList?.length) {
    doctorInfo?.departmentList?.forEach((departmentFilterItems: string) => {
      departmentList.forEach((departmentItems) => {
        if (departmentFilterItems === departmentItems.departmentId) {
          list.push(departmentItems);
        }
      });
    });
  } else {
    list.push(...departmentList);
  }
  return { departmentList: list };
};

// 获取该科室下的医生列表
export const queryDoctorList = async (departmentId = '', key = '') => {
  const doctorInfo = await getDoctorInfo();
  const { err, rsp }: any = await fly.post('/hospital/queryDoctorList', {
    hospitalId: doctorInfo.hospitalId,
    departmentId,
    key,
  });
  if (err) {
    throw new Error('弹窗拦截');
  }
  const doctorList = rsp?.doctorList || [];
  return { doctorList };
};

// 获取相应权限下医生列表
export const apiQueryPermDoctorList = async (departmentId = '', key = '') => {
  const doctorInfo = await getDoctorInfo();
  const { err, rsp }: any = await fly.post('/hospital/queryPermDoctorList', {
    hospitalId: doctorInfo.hospitalId,
    departmentId,
    key,
  });
  if (err) {
    throw new Error('弹窗拦截');
  }
  const doctorList = rsp?.doctorList || [];
  return { doctorList };
};

// 请求自动导入待确定、新增患者
export const getWaitConfirmPatientList = async (req = {}) => {
  const { err, patientList, totalCount }: any = await fly.post(
    '/hospital/FollowUpPatientImport/getWaitConfirmPatientList',
    req,
  );
  if (err) {
    throw new Error('弹窗拦截');
  }
  return { patientList, totalCount };
};

// 存量任务执行失败后，重新导入
export const retryImport = async (stockTaskId: string, taskType = TaskType.cyclePlan) => {
  const { err }: any = await fly.post('/hospital/FollowUpPatientImport/retryImport', {
    stockTaskId,
    taskType,
  });
  if (err) {
    throw new Error('弹窗拦截');
  }
};

// 获取自动导入默认配置
export const getAutoImportDefaultConfig = async () => {
  const res: any = await fly.post('/hospital/getAutoImportDefaultConfig', {});
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 引用模版
export const referQuestionnaire = (requireParams = {}) => fly.post('/hospital/referQuestionnaire', requireParams);

// 计划待确认总数
export const countFollowUpConfirm = async (req = {}) => {
  const res: any = await fly.post('/hospital/countFollowUpConfirm', req);
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res || {};
};

// 计划申请列表
export const getReviewList = async (req = {}) => {
  const res: any = await fly.post('/hospital/getFollowUpConfirmList', req);
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 同意或拒绝患者
export const updateFollowUpConfirmState = async (req = {}) => {
  const res: any = await fly.post('/hospital/updateFollowUpConfirmState', req);
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 计划配置
export const getPlanProjectSetting = async (followUpId: Number) => {
  const res: any = await fly.post('/hospital/getFollowUpProjectSetting', { followUpId });
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 随访权限管理Tab页接口-人员管理
export const getFollowUpManagerMemberList = async (req = {}) => {
  const res: any = await fly.post('/hospital/getFollowUpManagerMemberList', req);
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 获取所有管理员团队下的用户，用于修改管理员，管理员只能其中成员
export const searchAllAdminUser = async (req = {}) => {
  const res: any = await fly.post('/hospital/searchAllAdminUser', req);
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 修改随访权限管理Tab页，权限设置基本信息
export const updateFollowUpManagerInfo = async (req = {}) => {
  const res: any = await fly.post('/hospital/updateFollowUpManagerInfo', req);
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 查询医生用户列表
export const queryDoctorUserList = async (req = {}) => {
  const res: any = await fly.post('/hospital/queryDoctorUserList', req);
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 添加随访管理师
export const addFollowUpManagerMember = async (req = {}) => {
  const res: any = await fly.post('/hospital/addFollowUpManagerMember', req);
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 删除随访管理师
export const deleteFollowUpManagerMember = async (req = {}) => {
  const res: any = await fly.post('/hospital/deleteFollowUpManagerMember', req);
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 标记患者管理师
export const updateFollowPatientManagerMember = async (req = {}) => {
  const res: any = await fly.post('/hospital/updateFollowPatientManagerMember', req);
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 自动拉群并下发消息
export const setFollowUpManagerAutoGroupChat = async (req = {}) => {
  const res: any = await fly.post('/hospital/setFollowUpManagerAutoGroupChat', req);
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 筛选标签列表
export const apiGetCodeDictionary = async (req = {}) => {
  const res: any = await fly.post('/hospital/InnerHospitalArchive/getCodeDictionary', {
    pageIndex: 0,
    pageSize: 200,
    value: '',
    ...req,
  });
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

export const getInHospitalItemConf = async (type: string) => {
  const res: any = await fly.post('/hospital/getInHospitalItemConf', { type });
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 获取子计划匹配配置
export const getChildPlanMatchConfig = async (req: {
  childPlanId: number;
  followUpId: number;
  allDaySub: string;
}) => {
  const res: any = await fly.post('/hospital/getChildPlanMatchConfig', req);
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};

// 保存子计划匹配配置
export const upsertChildPlanMatchConfig = async (req: {
  childPlanId: number;
  followUpId: number;
  matchConfig: {
    source?: string; // 门诊：outpatient、急诊：emergency、住院：inpatient、体检：physicalExam，空为全部
    sourceType?: number; // 来源类型：0所有报告，1精准报告
    gender?: number; // 0-不限，1-male，2-female
    ageScope?: string; // 患者年龄，如40-70（40岁至70岁）
    departmentIds?: string; // 逗号分隔
    doctorIds?: string; // 逗号分隔
    dataPullTimes?: string; // 数据拉取时间点列表，多个用逗号分隔，如：09:00,14:00,19:00
    backtrackDay?: number; // 回溯天数
    reportBacktrackDay?: number; // 报告回溯天数
    updateKeyTime?: number; // 关键时间是否更新数据：0-否，1-是
  };
}) => {
  const res: any = await fly.post('/hospital/upsertChildPlanMatchConfig', req);
  if (res.err) {
    throw new Error('弹窗拦截');
  }
  return res;
};
